import { IContactsConfig } from "@/config/contacts.config";

// Ukraine-specific contacts configuration
const ukraineContactsConfig: IContactsConfig = {
  phone: "+380443334455",
  email: "info@avezor.ua",
  whatsapp: "https://wa.me/380443334455/",
  telegram: "https://t.me/avezor_ua",
  telegramBot: "https://t.me/avezoruabot",
  viber: "viber://chat?number=+380443334455",
  address: {
    en: "Khreschatyk 22, Kyiv",
    el: "Khreschatyk 22, Kyiv",
    ru: "Крещатик 22, Киев",
  },
  location: {
    city: "Kyiv",
    country: "Ukraine",
  },
};

export default ukraineContactsConfig;
